import { Button, useBreakpointValue } from "@chakra-ui/react";
import { t } from "i18next";

interface HintButtonProps {
  hintId: string;
  value: string;
  onReveal: (hint: string) => void;
}

export const HintButton = ({ hintId, value, onReveal }: HintButtonProps) => {
  const isRevealed = !!value;
  const buttonText = isRevealed
    ? value
    : useBreakpointValue({
        base: t(`game.controls.hints.mobile.${hintId}`),
        md: t(`game.controls.hints.${hintId}`),
      });

  return (
    <Button
      width="100%"
      onClick={() => !isRevealed && onReveal(hintId)}
      disabled={isRevealed}
      fontSize={{ base: "xs", lg: "md" }}
      _disabled={{
        backgroundColor: "blackAlpha.700",
        cursor: "not-allowed",
        opacity: 1,
        border: "1px solid",
        borderColor: "whiteAlpha.700",
      }}
    >
      {buttonText}
    </Button>
  );
};
